import { useState, useReducer, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useSnackbar } from "notistack";
import * as Yup from "yup";
import Monnify from "monnify-js";
import * as Action from "../../../store/redux/registrationReducer.js";
import axios from "axios";
import "./registration.css";
import Logo from "../public-routes-images/logos/Manga_Cons _Logo3.png";
import IsLoading from "../../../isLoading";
import { Link, useNavigate } from "react-router-dom";
import { statesAndLgas } from "./registrationStatesAndLGA.js";

let applicationData;
let appNo;

const ADMISSION_INFO = {
  session: "2026/2027",
  programme: "ND/HND General Nursing",
  openingDate: "15 July 2026",
  closingDate: "15 November 2026",
  fee: 10000,
};

export default function Registration() {
  const { enqueueSnackbar } = useSnackbar();
  const redirect = useNavigate();
  const dispatch = useDispatch();

  const [selectedState, setSelectedState] = useState("");
  const [localGovernments, setLocalGovernments] = useState([]);

  const [loading, setLoading] = useState(false);
  const [id, setId] = useState("");
  const [newApplicant, setNewApplicant] = useState("");
  const [paidsuccessful, setPaidsuccessfull] = useState(false);

  let continueationData;

  const [switchForm, setSwitchForm] = useState(0);

  const [applicantData, setApplicantData] = useReducer(
    (request, response) => {
      return { ...request, ...response };
    },
    {
      ref_number: null,
      transaction_id: "",
      state_of_address: "",
      application_number: "",
    },
  );

  const $adminAuth = useSelector(
    (state) => state.adminFunction?.isAuthenticated,
  );

  const actions = useSelector((state) => state.applictaionForm);

  const fd1 = actions?.firstDATA?.appFormData;
  const fd2 = actions?.secondDATA?.appFormData;

  const [referenceNo, setreferenceNo] = useState(null);
  const [transactionId, setTransactionId] = useState(null);

  const [AppNo, setAppNo] = useState("");

  /* =========================================================
     STATE / LGA
     ========================================================= */

  const handleStateChange = (e) => {
    const state = e.target.value;

    setSelectedState(state);

    setApplicantData({
      state_of_address: state,
    });

    setLocalGovernments(statesAndLgas[state] || []);
  };

  /* =========================================================
     APPLICATION SUBMISSION
     ========================================================= */

  const data = {
    first_name: fd1?.firstName,
    sur_name: fd1?.surName,
    other_name: fd1?.otherName,
    gender: fd1?.gender,
    email: fd1?.email,
    programme_of_study: fd1?.programme_of_study,
    course_of_study: fd1?.course_of_study,
    state_of_address: fd2?.state_of_address,
    lga_address: fd2?.lga_address,
    address: fd2?.address,
    phone_no: fd2?.phone_number,
    application_number: appNo,
    ref_number: referenceNo,
    transaction_id: transactionId,
  };

  const mailerData = {
    first_name: fd1?.firstName,
    sur_name: fd1?.surName,
    other_name: fd1?.otherName,
    application_number: fd2?.application_number,
    email: fd1?.email,
    programme_of_study: fd1?.programme_of_study,
    course_of_study: fd1?.course_of_study,
    ref_number: referenceNo,
    transaction_id: transactionId,
  };

  const executeApplication = async () => {
    try {
      setLoading(true); 
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER_SCRIPT_HOST}/student_application`,
        data,
      ); 

      console.log(response);

      applicationData = response.data.data;
      appNo = response.data?.data?.application_number;

      if (response.data?.status === 201) {
        enqueueSnackbar(`${response.data.message}`, {
          variant: "success",
          autoHideDuration: 3000,
          ContentProps: {
            style: {
              fontSize: "16px",
              fontWeight: "bold",
            },
          },
        });
        if (appNo) {
      redirect(`/registrations/${appNo}/print_reciept`);
    }
        
      } else {
        enqueueSnackbar(`${response.data.message}`, {
          variant: "error",
          autoHideDuration: 3000,
          ContentProps: {
            style: {
              fontSize: "16px",
              fontWeight: "bold",
            },
          },
        });
      }
    } catch (error) {
      enqueueSnackbar("Error: something went wrong!", {
        variant: "error",
        autoHideDuration: 3000,
        ContentProps: {
          style: {
            fontSize: "16px",
            fontWeight: "bold",
          },
        },
      });

      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  /* =========================================================
     REDIRECT AFTER SUCCESSFUL APPLICATION
     ========================================================= */

  // useEffect(() => {
  //   if (appNo) {
  //     redirect(`/registrations/${appNo}/print_reciept`);
  //   }
  // }, [redirect]);

  /* =========================================================
     PAYMENT
     ========================================================= */

  const email = fd1?.email;
  const phone_number = fd2?.phone_number;

  const name =
    `${fd1?.firstName || ""} ${fd1?.surName || ""} ${fd1?.otherName || ""}`.trim();

  function RegPaymentBtn() {
    const pay = () => {
      const monnify = new Monnify(
        `${process.env.REACT_APP_PAYMENTGATEWAY_API_KEY}`,
        `${process.env.REACT_APP_MY_CONTRACT_CODE}`,
      );

      monnify.initializePayment({
        amount: ADMISSION_INFO.fee,
        currency: "NGN",
        reference: new Date().getTime(),
        customerFullName: name,
        customerEmail: email,
        paymentDescription:
          "Payment for Application form fee of Manga College of Nursing Sciences",

        metadata: {
          application_No: `${appNo}`,
          full_name: `${name}`,
          email: `${email}`,
          phone_number: `${phone_number}`,
        },

        onLoadStart: () => {
          console.log("Monnify SDK loading started");
          setLoading(true);
        },

        onLoadComplete: () => {
          console.log("Monnify SDK is ready");
          setLoading(false);
        },

        onComplete: (response) => {
          setLoading(false);

          if (response.paymentStatus === "PAID") {
            setreferenceNo(response.paymentReference);
            setTransactionId(response.transactionReference);

            executeApplication();
          } else {
            enqueueSnackbar("Payment was not completed.", {
              variant: "warning",
              autoHideDuration: 4000,
            });
          }

          console.log("Transaction complete:", response);
        },

        onClose: (response) => {
          setLoading(false);

          console.log("Payment modal closed:", response);
        },
      });
    };

    return (
      <button
        type="button"
        className="payment-button"
        onClick={pay}
        disabled={loading}
      >
        <span>
          {loading
            ? "Processing..."
            : `Pay ₦${ADMISSION_INFO.fee.toLocaleString()}`}
        </span>

        {!loading && <span className="payment-arrow">→</span>}
      </button>
    );
  }

  /* =========================================================
     CONTINUE APPLICATION
     ========================================================= */

  const DispatchContinuetion = () => async (dispatch) => {
    try {
      dispatch(
        Action.continueAppForm({
          continueationData,
        }),
      );
    } catch (error) {
      console.log(error);
    }
  };

  async function executionAppVerification() {
    const application_number = AppNo?.trim();

    if (!application_number) {
      enqueueSnackbar("Please enter your application number.", {
        variant: "warning",
        autoHideDuration: 3000,
      });

      return;
    }

    try {
      setLoading(true);

      const response = await axios.post(
        `${process.env.REACT_APP_SERVER_SCRIPT_HOST}/verify_applicant`,
        {
          application_number,
        },
      );

      continueationData = response.data.data;

      if (
        response.data.data.account_status?.paymentStatus === "success"
      ) {
        dispatch(DispatchContinuetion());

        redirect(
          `/continue_application/${response.data.data.application_number}`,
        );
      } else {
        enqueueSnackbar("Invalid Application Number", {
          variant: "error",
          autoHideDuration: 4000,
        });
      }
    } catch (err) {
      console.log(err);

      enqueueSnackbar("Unable to verify application. Please try again.", {
        variant: "error",
        autoHideDuration: 4000,
      });
    } finally {
      setLoading(false);
    }
  }

  /* =========================================================
     FORM 1 — PERSONAL INFORMATION
     ========================================================= */

  const FormData = () => {
    const [appFormData, setAppFormData] = useReducer(
      (request, response) => {
        return {
          ...request,
          ...response,
        };
      },
      {
        firstName: "",
        surName: "",
        otherName: "",
        gender: "",
        email: "",
        programme_of_study: "",
        course_of_study: "",
      },
    );

    const [errors, setErrors] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);

    const validationSchema = Yup.object().shape({
      firstName: Yup.string().required("First name is required"),

      surName: Yup.string().required("Surname is required"),

      gender: Yup.string().required("Gender is required"),

      email: Yup.string()
        .email("Enter a valid email address")
        .required("Email is required"),

      programme_of_study: Yup.string().required(
        "Programme is required",
      ),

      course_of_study: Yup.string().required(
        "Course of study is required",
      ),
    });

    const validateForm = async () => {
      try {
        await validationSchema.validate(appFormData, {
          abortEarly: false,
        });

        setErrors({});

        return true;
      } catch (validationErrors) {
        const formattedErrors = {};

        validationErrors.inner.forEach((error) => {
          formattedErrors[error.path] = error.message;
        });

        setErrors(formattedErrors);

        return false;
      }
    };

    const execute = async () => {
      const isValid = await validateForm();

      if (!isValid) return;

      try {
        setIsSubmitting(true);

        dispatch(
          Action.startappFormAction({
            appFormData,
          }),
        );

        setSwitchForm(2);
      } finally {
        setIsSubmitting(false);
      }
    };

    return (
      <div className="registration-step">

        {/* STEP HEADER */}

        <div className="form-heading">

          <div>
            <span className="form-eyebrow">
              STEP 1 OF 3
            </span>

            <h2>Personal information</h2>

            <p>
              Tell us a little about yourself to begin your
              application.
            </p>
          </div>

          <div className="step-counter">
            01 <span>/ 03</span>
          </div>

        </div>


        {/* PROGRESS */}

        <ApplicationProgress currentStep={1} />


        {/* FORM */}

        <div className="form-section">

          <div className="form-section-title">
            <h3>Basic information</h3>

            <p>
              Enter your name exactly as it appears on your
              official documents.
            </p>
          </div>


          <div className="form-grid">

            <div
              className={`field ${
                errors.firstName ? "field-error" : ""
              }`}
            >
              <label htmlFor="firstName">
                First name <span>*</span>
              </label>

              <div className="input-shell">

                <input
                  id="firstName"
                  value={appFormData.firstName}
                  onChange={(event) =>
                    setAppFormData({
                      firstName: event.target.value,
                    })
                  }
                  type="text"
                  placeholder="Enter your first name"
                  autoComplete="given-name"
                />

              </div>

              {errors.firstName && (
                <small className="field-error-message">
                  {errors.firstName}
                </small>
              )}

            </div>


            <div
              className={`field ${
                errors.surName ? "field-error" : ""
              }`}
            >
              <label htmlFor="surName">
                Surname <span>*</span>
              </label>

              <div className="input-shell">

                <input
                  id="surName"
                  value={appFormData.surName}
                  onChange={(event) =>
                    setAppFormData({
                      surName: event.target.value,
                    })
                  }
                  type="text"
                  placeholder="Enter your surname"
                  autoComplete="family-name"
                />

              </div>

              {errors.surName && (
                <small className="field-error-message">
                  {errors.surName}
                </small>
              )}

            </div>

          </div>


          <div className="form-grid">

            <div className="field">

              <label htmlFor="otherName">
                Other name
              </label>

              <div className="input-shell">

                <input
                  id="otherName"
                  value={appFormData.otherName}
                  onChange={(event) =>
                    setAppFormData({
                      otherName: event.target.value,
                    })
                  }
                  type="text"
                  placeholder="Optional"
                />

              </div>

            </div>


            <div
              className={`field ${
                errors.gender ? "field-error" : ""
              }`}
            >

              <label htmlFor="gender">
                Gender <span>*</span>
              </label>

              <div className="input-shell">

                <select
                  id="gender"
                  value={appFormData.gender}
                  onChange={(event) =>
                    setAppFormData({
                      gender: event.target.value,
                    })
                  }
                >
                  <option value="" disabled>
                    Select gender
                  </option>

                  <option value="male">
                    Male
                  </option>

                  <option value="female">
                    Female
                  </option>

                </select>

              </div>

              {errors.gender && (
                <small className="field-error-message">
                  {errors.gender}
                </small>
              )}

            </div>

          </div>


          <div className="field full-field">

            <label htmlFor="email">
              Email address <span>*</span>
            </label>

            <div
              className={`input-shell ${
                errors.email ? "input-error" : ""
              }`}
            >

              <input
                id="email"
                value={appFormData.email}
                onChange={(event) =>
                  setAppFormData({
                    email: event.target.value,
                  })
                }
                type="email"
                placeholder="you@example.com"
                autoComplete="email"
              />

            </div>

            {errors.email && (
              <small className="field-error-message">
                {errors.email}
              </small>
            )}

          </div>


          <div className="form-section-divider"></div>


          <div className="form-section-title">
            <h3>Programme selection</h3>

            <p>
              Select the programme and course you wish to
              apply for.
            </p>
          </div>


          <div className="form-grid">

            <div
              className={`field ${
                errors.programme_of_study
                  ? "field-error"
                  : ""
              }`}
            >

              <label htmlFor="programme">
                Programme <span>*</span>
              </label>

              <div className="input-shell">

                <select
                  id="programme"
                  value={appFormData.programme_of_study}
                  onChange={(event) =>
                    setAppFormData({
                      programme_of_study:
                        event.target.value,
                    })
                  }
                >
                  <option value="" disabled>
                    Select programme
                  </option>

                  <option value="ND/HND">
                    ND/HND
                  </option>

                </select>

              </div>

              {errors.programme_of_study && (
                <small className="field-error-message">
                  {errors.programme_of_study}
                </small>
              )}

            </div>


            <div
              className={`field ${
                errors.course_of_study
                  ? "field-error"
                  : ""
              }`}
            >

              <label htmlFor="course">
                Course of study <span>*</span>
              </label>

              <div className="input-shell">

                <select
                  id="course"
                  value={appFormData.course_of_study}
                  onChange={(event) =>
                    setAppFormData({
                      course_of_study:
                        event.target.value,
                    })
                  }
                >
                  <option value="" disabled>
                    Select course
                  </option>

                  <option value="General Nursing">
                    General Nursing
                  </option>

                  <option value="Midwifery">
                    Midwifery
                  </option>

                </select>

              </div>

              {errors.course_of_study && (
                <small className="field-error-message">
                  {errors.course_of_study}
                </small>
              )}

            </div>

          </div>


          {/* ACTION */}

          <div className="form-actions">

            <button
              type="button"
              className="primary-button"
              onClick={execute}
              disabled={isSubmitting}
            >
              {isSubmitting
                ? "Saving..."
                : "Continue"}
              {!isSubmitting && <span>→</span>}
            </button>

          </div>

        </div>

      </div>
    );
  };


  /* =========================================================
     FORM 2 — CONTACT INFORMATION
     ========================================================= */

  const FormData2 = () => {

    const [appFormData, setAppFormData] = useReducer(
      (request, response) => {
        return {
          ...request,
          ...response,
        };
      },
      {
        application_number:
          applicantData.application_number,

        state_of_address:
          applicantData.state_of_address,

        lga_address: "",

        address: "",

        phone_number: "",

        ref_number: "",

        transaction_id: "",
      },
    );


    const [errors, setErrors] = useState({});


    const DispatchappFormData = () => async (dispatch) => {
      try {
        dispatch(
          Action.startappFormCont({
            appFormData,
          }),
        );
      } catch (error) {
        console.log(error);
      }
    };


    const validateForm = () => {

      const validationErrors = {};


      if (!appFormData.state_of_address) {
        validationErrors.state_of_address =
          "State is required.";
      }


      if (!appFormData.lga_address) {
        validationErrors.lga_address =
          "Local Government Area is required.";
      }


      if (!appFormData.address) {
        validationErrors.address =
          "Contact address is required.";
      }


      if (!appFormData.phone_number) {
        validationErrors.phone_number =
          "Phone number is required.";
      } else if (
        !/^\d{10}$/.test(appFormData.phone_number)
      ) {
        validationErrors.phone_number =
          "Phone number must be 10 digits.";
      }


      setErrors(validationErrors);

      return Object.keys(validationErrors).length === 0;
    };


    function execute() {

      if (validateForm()) {

        dispatch(
          DispatchappFormData(),
        );

        setSwitchForm(3);
      }
    }


    return (
      <div className="registration-step">

        {/* HEADER */}

        <div className="form-heading">

          <div>
            <span className="form-eyebrow">
              STEP 2 OF 3
            </span>

            <h2>Contact information</h2>

            <p>
              Provide your current residential and contact
              information.
            </p>
          </div>

          <div className="step-counter">
            02 <span>/ 03</span>
          </div>

        </div>


        <ApplicationProgress currentStep={2} />


        <div className="form-section">

          <div className="form-section-title">
            <h3>Residential information</h3>

            <p>
              Tell us where you currently reside.
            </p>
          </div>


          <div className="form-grid">

            {/* STATE */}

            <div
              className={`field ${
                errors.state_of_address
                  ? "field-error"
                  : ""
              }`}
            >

              <label htmlFor="state">
                State <span>*</span>
              </label>

              <div className="input-shell">

                <select
                  id="state"
                  value={selectedState}
                  onChange={handleStateChange}
                >
                  <option value="" disabled>
                    Select state
                  </option>

                  {Object.keys(statesAndLgas).map(
                    (state) => (
                      <option
                        key={state}
                        value={state}
                      >
                        {state}
                      </option>
                    ),
                  )}

                </select>

              </div>

              {errors.state_of_address && (
                <small className="field-error-message">
                  {errors.state_of_address}
                </small>
              )}

            </div>


            {/* LGA */}

            <div
              className={`field ${
                errors.lga_address
                  ? "field-error"
                  : ""
              }`}
            >

              <label htmlFor="lga">
                Local Government Area <span>*</span>
              </label>

              <div className="input-shell">

                <select
                  id="lga"
                  disabled={!selectedState}
                  value={appFormData.lga_address}
                  onChange={(event) =>
                    setAppFormData({
                      lga_address:
                        event.target.value,
                    })
                  }
                >

                  <option value="" disabled>
                    {selectedState
                      ? "Select LGA"
                      : "Select state first"}
                  </option>

                  {localGovernments.map(
                    (lga) => (
                      <option
                        key={lga}
                        value={lga}
                      >
                        {lga}
                      </option>
                    ),
                  )}

                </select>

              </div>

              {errors.lga_address && (
                <small className="field-error-message">
                  {errors.lga_address}
                </small>
              )}

            </div>

          </div>


          {/* ADDRESS */}

          <div
            className={`field full-field ${
              errors.address ? "field-error" : ""
            }`}
          >

            <label htmlFor="address">
              Contact address <span>*</span>
            </label>

            <div className="input-shell textarea-shell">

              <textarea
                id="address"
                value={appFormData.address}
                onChange={(event) =>
                  setAppFormData({
                    address: event.target.value,
                  })
                }
                placeholder="Enter your complete residential address"
                rows="5"
              />

            </div>

            {errors.address && (
              <small className="field-error-message">
                {errors.address}
              </small>
            )}

          </div>


          {/* PHONE */}

          <div
            className={`field full-field ${
              errors.phone_number
                ? "field-error"
                : ""
            }`}
          >

            <label htmlFor="phone">
              Phone number <span>*</span>
            </label>

            <div className="phone-input-shell">

              <div className="country-code">

                <span className="nigeria-flag">
                  <span></span>
                  <span></span>
                  <span></span>
                </span>

                <strong>
                  +234
                </strong>

              </div>


              <div className="input-shell">
              <input
                id="phone"
                value={appFormData.phone_number}
                onChange={(event) => {

                  const value =
                    event.target.value
                      .replace(/\D/g, "")
                      .slice(0, 10);

                  setAppFormData({
                    phone_number: value,
                  });

                }}
                type="tel"
                inputMode="numeric"
                placeholder="8012345678"
                autoComplete="tel"
              />

              </div>

            </div>

            <small className="field-hint">
              Enter your Nigerian phone number without
              the +234 prefix.
            </small>

            {errors.phone_number && (
              <small className="field-error-message">
                {errors.phone_number}
              </small>
            )}

          </div>


          <div className="form-actions">

            <button
              type="button"
              className="secondary-button"
              onClick={() => setSwitchForm(1)}
            >
              ← Back
            </button>


            <button
              type="button"
              className="primary-button"
              onClick={execute}
            >
              Review application
              <span>→</span>
            </button>

          </div>

        </div>

      </div>
    );
  };


  /* =========================================================
     PAYMENT DETAILS
     ========================================================= */

  const PaymentDetails = () => {

    const wakeUP = async () => {

      try {

        await axios.get(
          `${process.env.REACT_APP_SERVER_SCRIPT_HOST}/wakeUP`,
        );

        console.log("Server live");

      } catch (error) {

        console.log(error);

      }

    };


    useEffect(() => {
      wakeUP();
    }, []);


    return (
      <div className="registration-step">

        {/* HEADER */}

        <div className="form-heading">

          <div>
            <span className="form-eyebrow">
              STEP 3 OF 3
            </span>

            <h2>Review & payment</h2>

            <p>
              Review your application fee before completing
              payment.
            </p>
          </div>

          <div className="step-counter">
            03 <span>/ 03</span>
          </div>

        </div>


        <ApplicationProgress currentStep={3} />


        <div className="payment-layout">

          {/* MAIN PAYMENT */}

          <div className="payment-main">

            <div className="payment-header">

              <span className="payment-secure">
                🔒 SECURE PAYMENT
              </span>

              <h3>
                Complete your application
              </h3>

              <p>
                You are one step away from completing your
                application for the 2026/2027 session.
              </p>

            </div>


            <div className="payment-summary">

              <div className="payment-row">

                <div className="payment-product">

                  <span className="payment-product-icon">
                    ✓
                  </span>

                  <div>

                    <span>
                      Application
                    </span>

                    <strong>
                      {ADMISSION_INFO.programme}
                    </strong>

                  </div>

                </div>


                <strong>
                  ₦
                  {ADMISSION_INFO.fee.toLocaleString()}
                </strong>

              </div>


              <div className="payment-divider"></div>


              <div className="payment-row">

                <span>
                  Application form fee
                </span>

                <strong>
                  ₦
                  {ADMISSION_INFO.fee.toLocaleString()}
                </strong>

              </div>


              <div className="payment-total">

                <div>

                  <span>
                    Total payable
                  </span>

                  <small>
                    Nigerian Naira
                  </small>

                </div>

                <strong>
                  ₦
                  {ADMISSION_INFO.fee.toLocaleString(
                    undefined,
                    {
                      minimumFractionDigits: 2,
                    },
                  )}
                </strong>

              </div>

            </div>


            <div className="payment-actions">

              <button
                type="button"
                className="secondary-button"
                onClick={() => setSwitchForm(2)}
              >
                ← Back
              </button>

              <RegPaymentBtn />

            </div>

          </div>


          {/* SECURITY PANEL */}

          <aside className="payment-security">

            <div className="security-icon">
              ✓
            </div>

            <h3>
              Secure payment
            </h3>

            <p>
              Your payment is processed securely through
              our online payment gateway.
            </p>


            <div className="security-item">
              ✓ Secure transaction
            </div>

            <div className="security-item">
              ✓ Instant payment confirmation
            </div>

            <div className="security-item">
              ✓ Application receipt generated
            </div>

          </aside>

        </div>

      </div>
    );
  };


  /* =========================================================
     APPLICATION PROGRESS
     ========================================================= */

  const ApplicationProgress = ({ currentStep }) => {

    const steps = [
      {
        number: 1,
        title: "Personal",
        description: "Basic information",
      },
      {
        number: 2,
        title: "Contact",
        description: "Address & phone",
      },
      {
        number: 3,
        title: "Payment",
        description: "Complete application",
      },
    ];


    return (
      <div className="application-progress">

        {steps.map((step, index) => {

          const completed =
            currentStep > step.number;

          const active =
            currentStep === step.number;

          return (
            <div
              className="progress-wrapper"
              key={step.number}
            >

              <div
                className={`progress-step ${
                  completed
                    ? "completed"
                    : active
                    ? "active"
                    : ""
                }`}
              >

                <div className="progress-icon">

                  {completed
                    ? "✓"
                    : step.number}

                </div>

                <div>

                  <strong>
                    {step.title}
                  </strong>

                  <span>
                    {step.description}
                  </span>

                </div>

              </div>


              {index < steps.length - 1 && (
                <div
                  className={`progress-line ${
                    currentStep > step.number
                      ? "active"
                      : ""
                  }`}
                ></div>
              )}

            </div>
          );
        })}

      </div>
    );
  };


  /* =========================================================
     START APPLICATION
     ========================================================= */

  const ApplicationStart = ({
    onStart,
    onContinue,
  }) => {

    return (
      <div className="application-start">

        <div className="start-welcome">

          <div className="start-logo">

            <img
              src={Logo}
              alt="Manga College of Nursing Sciences"
            />

          </div>


          <span className="form-eyebrow">
            2026/2027 ADMISSION
          </span>


          <h2>
            Begin your
            <span> nursing journey.</span>
          </h2>


          <p>
            Applications are currently open for the
            {` ${ADMISSION_INFO.programme}`}.
            Complete your application online in a few
            simple steps.
          </p>

        </div>


        <div className="application-open-card">

          <div className="open-card-top">

            <div>

              <span>
                APPLICATION STATUS
              </span>

              <strong>
                Applications Open
              </strong>

            </div>


            <span className="open-label">
              OPEN
            </span>

          </div>


          <div className="application-date">

            <div>

              <small>
                Opens
              </small>

              <strong>
                {ADMISSION_INFO.openingDate}
              </strong>

            </div>


            <div className="date-arrow">
              →
            </div>


            <div>

              <small>
                Closes
              </small>

              <strong>
                {ADMISSION_INFO.closingDate}
              </strong>

            </div>

          </div>

        </div>


        <div className="application-actions">

          <button
            type="button"
            className="primary-button"
            onClick={onStart}
          >
            Start new application
            <span>→</span>
          </button>


          <button
            type="button"
            className="secondary-button"
            onClick={onContinue}
          >
            Continue existing application
          </button>

        </div>


        <div className="application-help">

          <div className="help-item">
            <span>✓</span>
            <strong>
              Simple online application
            </strong>
          </div>

          <div className="help-item">
            <span>✓</span>
            <strong>
              Secure online payment
            </strong>
          </div>

          <div className="help-item">
            <span>✓</span>
            <strong>
              Instant application receipt
            </strong>
          </div>

        </div>


        <div className="existing-login">

          Already have an account?

          <Link to="/student_login">
            Sign in
          </Link>

        </div>

      </div>
    );
  };


  /* =========================================================
     CONTINUE APPLICATION SCREEN
     ========================================================= */

  const ContinueApplication = () => {

    return (
      <div className="continue-application">

        <div className="continue-icon">
          ↻
        </div>


        <span className="form-eyebrow">
          EXISTING APPLICATION
        </span>


        <h2>
          Continue your application
        </h2>


        <p>
          Enter your application number below to continue
          where you left off.
        </p>


        <div className="continue-form">

          <div className="field">

            <label htmlFor="applicationNumber">
              Application number
            </label>

            <div className="input-shell">

              <input
                id="applicationNumber"
                value={AppNo}
                onChange={(event) =>
                  setAppNo(event.target.value)
                }
                type="text"
                placeholder="Enter your application number"
                autoComplete="off"
              />

            </div>

          </div>


          <button
            type="button"
            className="primary-button full-button"
            onClick={executionAppVerification}
            disabled={loading}
          >

            {loading
              ? "Verifying..."
              : "Continue application"}

            {!loading && <span>→</span>}

          </button>


          <button
            type="button"
            className="text-button"
            onClick={() => {

              setNewApplicant("");
              setSwitchForm(0);
              setAppNo("");

            }}
          >
            ← Start a new application
          </button>

        </div>

      </div>
    );
  };


  /* =========================================================
     FORM SWITCH
     ========================================================= */

  const formSwitching = () => {

    switch (switchForm) {

      case 1:
        return <FormData />;

      case 2:
        return <FormData2 />;

      case 3:
        return <PaymentDetails />;

      default:
        return null;
    }
  };


  /* =========================================================
     HANDLERS
     ========================================================= */

  function handleNewApp() {

    setNewApplicant("new-application");
    setSwitchForm(1);
  }


  function handleExistedApp() {

    setNewApplicant("continue-application");
  }


  /* =========================================================
     MAIN RENDER
     ========================================================= */

  return (
    <>

      {loading && <IsLoading />}


      <section className="admission-page">

        {/* =====================================================
            HEADER
        ===================================================== */}

        <header className="admission-header">

          <div className="admission-brand">

            <img
              src={Logo}
              alt="Manga College of Nursing Sciences"
            />

          </div>


          <div className="admission-session">

            <span className="session-badge">
              {ADMISSION_INFO.session} SESSION
            </span>


            <span className="status-badge">

              <span className="status-dot"></span>

              Applications Open

            </span>

          </div>

        </header>


        {/* =====================================================
            MAIN APPLICATION SHELL
        ===================================================== */}

        <main className="admission-shell">

          {/* ===================================================
              SIDEBAR
          =================================================== */}

          <aside className="admission-sidebar">

            <div className="sidebar-content">

              <span className="eyebrow">
                MANGA-CONS ADMISSIONS
              </span>


              <h1>
                Start your journey
                <span>
                  {" "}
                  in nursing.
                </span>
              </h1>


              <p className="sidebar-description">

                Complete your application for the
                {` ${ADMISSION_INFO.session} `}
                academic session. Your application can
                be completed in just a few simple steps.

              </p>


              <div className="admission-status-card">

                <div className="status-card-header">

                  <span>
                    Application status
                  </span>

                  <span className="open-label">
                    OPEN
                  </span>

                </div>


                <div className="application-date">

                  <div>

                    <small>
                      Opened
                    </small>

                    <strong>
                      15 Jul 2026
                    </strong>

                  </div>


                  <div className="date-arrow">
                    →
                  </div>


                  <div>

                    <small>
                      Closes
                    </small>

                    <strong>
                      15 Nov 2026
                    </strong>

                  </div>

                </div>

              </div>


              <div className="benefit-list">

                <div className="benefit-item">

                  <span className="benefit-icon">
                    ✓
                  </span>

                  <div>

                    <strong>
                      Simple online application
                    </strong>

                    <p>
                      Complete your application from
                      anywhere.
                    </p>

                  </div>

                </div>


                <div className="benefit-item">

                  <span className="benefit-icon">
                    ✓
                  </span>

                  <div>

                    <strong>
                      Secure payment
                    </strong>

                    <p>
                      Pay your application fee securely
                      online.
                    </p>

                  </div>

                </div>


                <div className="benefit-item">

                  <span className="benefit-icon">
                    ✓
                  </span>

                  <div>

                    <strong>
                      Track your application
                    </strong>

                    <p>
                      Continue an existing application
                      anytime.
                    </p>

                  </div>

                </div>

              </div>

            </div>

          </aside>


          {/* ===================================================
              FORM AREA
          =================================================== */}

          <section className="admission-form-area">

            {newApplicant === "continue-application" ? (

              <ContinueApplication />

            ) : (

              <>

                {switchForm === 0 && (

                  <ApplicationStart
                    onStart={handleNewApp}
                    onContinue={handleExistedApp}
                  />

                )}


                {switchForm > 0 && (

                  <div className="student-registration-form">

                    {formSwitching()}

                  </div>

                )}

              </>

            )}

          </section>

        </main>


        {/* =====================================================
            FOOTER
        ===================================================== */}
        <div className="fx-ac fx-jc spacem">
          
          <span>
            © {new Date().getFullYear()}
            {" "}
            Manga College of Nursing Sciences
          </span>
        </div>

        {/* <footer className="admission-footer">

          <span>
            © {new Date().getFullYear()}
            {" "}
            Manga College of Nursing Sciences
          </span>


          <div>

            <Link to="/student_login">
              Applicant Login
            </Link>

            <Link to="/mangacons_requirement">
              Admission Requirements
            </Link>

          </div>

        </footer> */}

      </section>

    </>
  );
}